'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CalendarEmpty = require('./CalendarEmpty');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CalendarEmpty).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CalendarEmpty/index.js
// module id = 1126
// module chunks = 1